import type { Notification } from '@/store/notifications/notificationsSlice'
import type { Task } from '@/contexts/TasksContext'
import { PROJECT_TITLE } from '@/const/titles.ts'

// A notification outlives the entity it points at (a deleted task's notifications are
// cascaded server-side now, but old orphans still exist), so name that state explicitly.
// The former fallback built `${prefix}-${task?.number ?? n.taskId}`, which — with no task —
// always rendered the Firestore doc id, e.g. "SCD-EVLHeEhjmmaGpL9LtyL0".
export const DELETED_TASK_TITLE = 'Deleted task'

interface NotificationTitleArgs {
    notification: Notification
    task?: Task
    project?: { name?: string }
    // True once BOTH task listeners (open + completed) have delivered a snapshot — only
    // then does a missing task mean "deleted" rather than "not loaded yet".
    tasksLoaded: boolean
}

export const getNotificationTitle = ({ notification, task, project, tasksLoaded }: NotificationTitleArgs): string => {
    if (notification.taskId) {
        if (task) return task.name
        return tasksLoaded ? DELETED_TASK_TITLE : ''
    }
    if (notification.projectId) return project?.name || PROJECT_TITLE
    return ''
}
